import React, { Component } from "react";
import firebaseManager from "../../../model/Firebase/FirebaseManager";
import BarraSupDent from "../../../commons/BarraSupDent";
import { Redirect } from "react-router-dom";

class NewUserAuth extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.signup = this.signup.bind(this);
    this.state = {
      email: "",
      password: "",
      firstName: "",
      lastname: "",
      phoneNumber: "",
      redirectToHome: false,
    };
  }

  signup(e) {
    e.preventDefault();
    if (this.state.phoneNumber === "") {
      document.getElementById("alert").classList.remove("d-none");
    } else {
      firebaseManager.createUser(
        this.state.email,
        this.state.password,
        this.state.firstName,
        this.state.lastname,
        this.state.phoneNumber,
        this.loginCallbackSuccess,
        this.loginCallbackFail
      );
    }
  }

  loginCallbackSuccess = () => {
    this.setState({
      redirectToHome: true,
    });
  };

  loginCallbackFail(errMessage) {
    alert(errMessage);
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  render() {
    return (
      <React.Fragment>
        {this.state.redirectToHome ? <Redirect push to="/car_info" /> : null}
        <BarraSupDent />
        <div id="alert" className="alert alert-danger d-none" role="alert">
          <p className="text-center">Please enter your phone number</p>
        </div>
        <div className="text-center mt-5">
          <form name="theform" className="mx-auto mt-5">
            <div className="form-group">
              <p className="text-center mt-5">Name</p>
              <input
                type="text"
                id="firstName"
                name="firstName"
                onChange={this.handleChange}
                value={this.state.firstName}
                className=" size"
                placeholder="First"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                id="lastname"
                name="lastname"
                onChange={this.handleChange}
                value={this.state.lastname}
                className=" size"
                placeholder="Last"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                onChange={this.handleChange}
                value={this.state.phoneNumber}
                className=" size"
                placeholder="Phone Number"
                required
              />
            </div>
            <div className="form-group">
              <p className="text-center mt-4">Login Info</p>
              <input
                type="email"
                name="email"
                id="email"
                onChange={this.handleChange}
                value={this.state.email}
                className=" size"
                aria-describedby="emailHelp"
                placeholder="Email"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                id="password"
                name="password"
                onChange={this.handleChange}
                value={this.state.password}
                className=" size"
                placeholder="Password"
                required
              />
            </div>
            <button onClick={this.signup} className="btn btn-secondary mb-5 mt-5">
              Signup
            </button>
          </form>
        </div>
      </React.Fragment>
    );
  }
}
export default NewUserAuth;
